import React from 'react'
import { Box, Flex } from '../../new/core-components/box'

import { SystemProps } from '../../new/theme'
import { ThemeColors } from '../../new/theme/colors'
import { InputState } from './InputState'
import { FloatingTextStyled, LabelStyled, TextAnimationStyled } from './label.styled'

export type LabelStyle = 'control' | 'embedded'

interface Props {
  active: boolean
  children?: React.ReactNode
  color?: ThemeColors
  customStyles?: SystemProps
  id?: string
  inputState: InputState
  label?: string
  labelPosition?: 'above' | 'below'
  labelStyle?: LabelStyle
  textArea?: boolean
}

export const Label = ({
  label,
  id,
  inputState,
  children,
  color,
  labelStyle = 'control',
  textArea,
  customStyles,
  active,
  labelPosition = 'above',
}: Props) => {
  const colors: Record<InputState, ThemeColors> = {
    [InputState.Focused]: 'text/form-label-moderate',
    [InputState.Invalid]: 'text/form-label-moderate',
    [InputState.Disabled]: 'text/form-label-moderate',
    [InputState.Idle]: color || 'text/form-label-moderate',
  }

  if (!label) {
    return (
      <Box w='100%' h='100%' px={textArea ? 5 : 4} py={textArea ? 4 : 2} {...customStyles}>
        {children}
      </Box>
    )
  }

  return (
    <LabelStyled htmlFor={id}>
      <Flex
        data-test-id='input-label-flex-container'
        flexDirection={labelPosition === 'above' ? 'column' : 'column-reverse'}
        h='100%'
        w='100%'
        py={4}
        px={5}
        justifyContent={textArea ? 'flex-start' : 'center'}
        {...customStyles}
      >
        <FloatingTextStyled
          mb={labelStyle === 'embedded' ? 1 : 0}
          active={active}
          textArea={textArea}
          isAbove={labelPosition === 'above'}
        >
          <TextAnimationStyled
            fontSize={12}
            fontWeight={600}
            color={colors[inputState] as ThemeColors}
          >
            {label}
          </TextAnimationStyled>
        </FloatingTextStyled>
        <Flex h='100%' w='100%' alignItems='start'>
          <Flex h='100%' w='100%'>
            <Box w='100%' h='100%'>
              {children}
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </LabelStyled>
  )
}
